class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) {
      return;
    }

    this.mainDetailsToggle.addEventListener('click', this.toggleDetails.bind(this));

    document.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  toggleDetails(event) {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');

    if (!isOpen) {
      const openDetailsElements = document.querySelectorAll('details[open]');

      openDetailsElements.forEach((openDetails) => {
        if (openDetails !== this.mainDetailsToggle) {
          openDetails.removeAttribute('open');

          const openSummary = openDetails.querySelector('summary');

          if (openSummary) {
            openSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }
  }

  onFocusOut(event) {
    const relatedTarget = event.relatedTarget;

    if (
      relatedTarget &&
      relatedTarget.closest('.header__dropdown__item__items')
    ) {
      return;
    }

    const headerDropdowns = document.querySelectorAll('.header__dropdown');

    headerDropdowns.forEach((headerDropdown) => {

      const detailsElements = headerDropdown.querySelectorAll('details');
      detailsElements.forEach((detailsElement) => {

        detailsElement.removeAttribute('open');

        // In hover mode submenus render as plain divs with no <summary>,
        // so this can legitimately be null.
        const summaryElement = detailsElement.querySelector('summary');

        if (summaryElement) {
          summaryElement.setAttribute('aria-expanded', 'false');
        }

        const dropdownItems = detailsElement.querySelectorAll(
          '.header__dropdown__item__items a'
        );
        dropdownItems.forEach((item) => {
          item.setAttribute('tabindex', '-1');
        });
      });
    });
  }

  close() {
    if (!this.mainDetailsToggle) {
      return;
    }

    this.mainDetailsToggle.removeAttribute('open');

    const summary = this.mainDetailsToggle.querySelector('summary');

    if (summary) {
      summary.setAttribute('aria-expanded', false);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
